import { type FC, useState } from "react";
import { DISABLED_CONTROL } from "../../../theme/tokens";
import SystemButton from "../SystemButton/SystemButton";

type Props = {
	/** Already-translated label, e.g. "Undo". */
	label: string;
	onClick: () => void;
	/** Disable after the first press, for actions like Undo that must not run twice. */
	singleUse?: boolean;
	dataTestId: string;
};

/** A text button inside a toast. It uses the toast's text color so it reads on every severity. */
export const SnackbarActionButton: FC<Props> = ({ label, onClick, singleUse, dataTestId }) => {
	const [used, setUsed] = useState(false);

	const handleClick = () => {
		if (singleUse) setUsed(true);
		onClick();
	};

	return (
		<SystemButton
			buttonVariant="borderless"
			size="compact"
			noFullWidthMobile
			disabled={used}
			onClick={handleClick}
			data-testid={dataTestId}
			sx={{
				backgroundColor: "transparent",
				color: "inherit",
				fontWeight: 700,
				"&:hover": { backgroundColor: "action.hover", textDecoration: "underline" },
				"&.Mui-disabled": { backgroundColor: "transparent", color: "inherit", opacity: DISABLED_CONTROL.DIMMED_OPACITY },
			}}
		>
			{label}
		</SystemButton>
	);
};

export default SnackbarActionButton;
